import React, { useEffect, useState } from "react";
import i18n from "../../i18n";
import { HashRouter as Router } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { Stores } from "../../types";
import { SessionStore } from "../../stores/Session";
import { StoresContext } from "../../contexts";
import { observer } from "mobx-react";
import { ChakraProvider } from "@chakra-ui/react";
import { UiStore } from "../../stores/UI";
import { extendTheme } from "@chakra-ui/react";
import { mainTheme } from "../../config/theme";
import { ClientsStore } from "../../stores/ClientsStore";
import dayjs from "dayjs";
import "dayjs/locale/it";
import moment from "moment";
import { Navigation } from "./Navigation";
import { StepsStyleConfig as Steps } from "chakra-ui-steps";

moment.locale("it");
const Root: React.FC = observer(() => {
  // https://coolors.co/image-picker
  // https://materialpalettes.com/
  const theme = extendTheme({
    components: {
      Button: {
        baseStyle: {
          borderRadius: "2rem",
        },
      },
      Steps,
    },
    colors: {
      purple: {
        50: "#f2e5f2",
        100: "#dfbde1",
        200: "#ca92cd",
        300: "#b468b9",
        400: "#a449aa",
        500: "#942d9c",
        600: "#872996",
        700: "#76238e",
        800: "#661f85",
        900: "#4a1775",
      },
    },
  });

  const [stores] = useState<Stores>(() => {
    const root: Stores = {} as Stores;

    root.session = new SessionStore(root);
    root.clientsStore = new ClientsStore(root);
    root.ui = new UiStore(root);

    return root;
  });

  useEffect(() => {
    i18n.changeLanguage("it");
    dayjs.locale("it");
  }, []);

  useEffect(() => {
    if (!stores.session.isInitialized) {
      stores.session.initialize();
    }
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <ChakraProvider theme={theme}>
        <StoresContext.Provider value={stores}>
          <Router>
            <Navigation />
          </Router>
        </StoresContext.Provider>
      </ChakraProvider>
    </ThemeProvider>
  );
});

export default styled(Root)`
  & {
    min-height: 100vh;
  }
`;
